import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import WorkspacesHeader from "layout/systemAdmin/workspaces/WorkspacesHeader";
import WorkspacesCreate from "layout/systemAdmin/workspaces/WorkspacesCreate";
import { fetchWorkspaces } from "slices/systemAdmin/actions/systemAdmin";
import {
  setTabActive,
  setWorkspacesSearchTerm,
} from "slices/systemAdmin/systemAdminSlice";
import WorkspacesContentBody from "layout/systemAdmin/workspaces/WorkspacesContentBody";
import { fetchUsers } from "slices/systemAdmin/actions/users";
import { addToJobQueue } from "slices/app/appSlice";

const WorkspacesContent = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(addToJobQueue("genericJob"));
    dispatch(setTabActive(0));
    dispatch(setWorkspacesSearchTerm(""));
    dispatch(fetchWorkspaces());
    dispatch(fetchUsers());
  }, []);

  return (
    <>
      <WorkspacesHeader />
      <div className="header__container">
        <div
          className="system_admin__container__header"
          data-testid="workspaces-content-header"
        >
          <span className="system_admin__container__header__workspace">
            Workspace
          </span>
          <span className="system_admin__container__header__licensed">
            Licensed Users
          </span>
          <span className="system_admin__container__header__non_licensed">
            Non Licensed Users
          </span>
          <span className="system_admin__container__header__reserved_licenses">
            Reserved Licenses
          </span>
          <span className="system_admin__container__header__banner">
            Banner Message
          </span>
          <span className="system_admin__container__header__actions" />
        </div>
      </div>
      <div className="system_admin__container">
        <WorkspacesContentBody />
      </div>
      <div className="system_admin__create__workspace__empty__row" />
      <WorkspacesCreate />
    </>
  );
};

export default WorkspacesContent;
